import { useState } from 'react';
import { NAVY } from '../../styles/tokens';

const NOMINA_SENDBACK_REASONS = [
  'Empleado incorrecto o faltante',
  'Horas regulares incorrectas',
  'Horas extra incorrectas',
  'Tarea/fase incorrecta',
  'Fecha incorrecta',
  'Otro',
];

export default function NominaSendBackModal({ sheetDate, onConfirm, onCancel }) {
  const [reason, setReason] = useState('');
  const [notes, setNotes]   = useState('');

  const canSubmit = !!reason;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }}>
      <div style={{
        background: '#fff',
        border: `1.5px solid ${NAVY}`,
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(27,58,107,0.18)',
        padding: '28px 32px',
        maxWidth: 460,
        width: '92%',
        maxHeight: '90vh',
        overflowY: 'auto',
        animation: 'fadeUp 0.2s ease',
      }}>
        <div style={{ fontSize: 18, fontWeight: 'bold', color: '#E67E22', marginBottom: 6 }}>
          ↩ Devolver Tarjeta
        </div>
        {sheetDate && (
          <div style={{ fontSize: 13, color: '#666', marginBottom: 20 }}>
            Tarjeta del {sheetDate}
          </div>
        )}

        <div style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 10 }}>
          Motivo <span style={{ color: '#c0392b' }}>*</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 18 }}>
          {NOMINA_SENDBACK_REASONS.map((r) => (
            <label key={r} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 13 }}>
              <input
                type="radio"
                name="nomina-sendback-reason"
                value={r}
                checked={reason === r}
                onChange={() => setReason(r)}
                style={{ accentColor: NAVY }}
              />
              {r}
            </label>
          ))}
        </div>

        <div style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 }}>
          Notas para el supervisor <span style={{ color: '#999', fontWeight: 'normal' }}>(opcional)</span>
        </div>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={3}
          placeholder="Detalles adicionales sobre lo que debe corregir..."
          style={{
            width: '100%', borderRadius: 6, border: '1px solid #c8d4e8',
            padding: '8px 10px', fontSize: 13, fontFamily: 'Inter, sans-serif',
            background: '#F0F3F8', resize: 'vertical', marginBottom: 20,
          }}
        />

        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={() => onConfirm({ reason, notes })}
            disabled={!canSubmit}
            style={{
              flex: 1, background: canSubmit ? '#E67E22' : '#e0e0e0',
              color: '#fff', border: 'none', borderRadius: 8,
              padding: '10px 0', fontWeight: 'bold', fontSize: 14,
              cursor: canSubmit ? 'pointer' : 'not-allowed',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            ↩ Devolver
          </button>
          <button
            onClick={onCancel}
            style={{
              flex: 1, background: '#fff', color: NAVY,
              border: `1.5px solid ${NAVY}`, borderRadius: 8,
              padding: '10px 0', fontWeight: 'bold', fontSize: 14,
              cursor: 'pointer', fontFamily: 'Inter, sans-serif',
            }}
          >
            ← Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
